import React, { FC, createRef, useState, useEffect, useRef, Fragment } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
// import { goBack } from 'connected-react-router'
// import type { DatePickerProps } from 'antd'
import type { FormInstance } from 'antd/es/form'
import {
    Space, Form, Input, Button, Typography, Select, notification, Popover, DatePicker, InputNumber, List,
    Radio, Row, Col
} from 'antd'
import Icon, {
    PlusCircleOutlined, SmileOutlined, CheckCircleOutlined, MinusCircleOutlined, DeleteOutlined,
    LoadingOutlined,
} from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
// import moment from 'moment'
import type { IAppState } from '@/store/reducers'
import type { Descendant } from 'slate'
import { Text } from 'slate'
import DSlate, { DefaultPlugin } from '@dslate/dslate'
import type { DSlateRef } from '@dslate/core'
import { ConfigProvider, defaultConfig } from '@dslate/core'
import { jsx } from 'slate-hyperscript'
import { getProjectInfoById, getWorkgroup } from '@/store/actions/tableEdit.action'
// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
import type { IWorkgroupObj, IClassification, ITechYearQuarters } from '@/store/models/tableEdit.model'
import { addProjectInfo, editProjectInfo, getTechClassificationListAll } from '@/services/table.service'
import { getErrorStr } from '@/store/sagas/table.saga'
import { requestFail } from '@/store/actions/common.action'
import { setEdit2Data } from '@/store/actions/tableEdit.action'
import { ValidateStatus } from '@/store/constant/table.constant'
import PageBreadcrumb from '@/components/pageBreadcrumb'
import NoSpaceInput from '@/components/noSpaceInput'
import { getUuid, ltrim, rtrim } from '@/utils/util'
import _ from 'lodash'
import { getDicClass } from '@/pages/charts'
import { getOnlineReviewById } from '@/services/progress.service'
import SelectBU from '@/components/selectBU'
import SelectProject from '@/pages/table2Mana/components/selectProjects'
import { IBu } from '@/store/models/auth.model'
import { getProdList } from '@/services/progress.service'
import { getStandardName } from '@/services/rag'
import Nav from '@/components/nav'

interface IYearSelect {
    value?: number
    validateStatus?: ValidateStatus | undefined
    message?: string
}

// const arr = ['微服务 Micro Service', '数据存储 Data Storage', '自动标注 Automatic Annotation', '边缘计算 Edge Computation', '无钥匙进入及启动系统 PEPS', '差分算法 Differential Algorithm', '以太网协议栈  Ethernet protocol stack', '远程诊断   Remote diagnostic', '测试和评估 Assessment and Test']

// 处理前后空格
export const handleTrim = (arr: any[]): any => {
    const _arr = _.cloneDeep(arr)
    // 第一个节点去掉左空格
    let firstNode = _arr[0]
    while ('type' in firstNode) {
        firstNode = firstNode.children[0]
    }
    firstNode.text = ltrim(firstNode.text)
    // 最后一个节点去掉右空格
    let lastNode = _arr[_arr.length - 1]
    while ('type' in lastNode) {
        lastNode = lastNode.children[lastNode.children.length - 1]
    }
    lastNode.text = rtrim(lastNode.text)
    return _arr
}

export const serialize = (children: any[]): any => {
    return children.map((node: any) => {
        if (Text.isText(node)) {
            return {
                ...node,
                text: node.text.replace(/ /g, '\xa0')
            }
        }
        return {
            ...node,
            children: serialize(node.children)
        }
    })
}

//去掉所有的html标记
function delHtmlTag(str: string) {
    return str.replace(/<[^>]+>/g, '')
}

// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
const deserialize = (el: any) => {
    if (el.nodeType === 3) {
        return el.textContent
    } else if (el.nodeType !== 1) {
        return null
    }

    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    const children: any = Array.from(el.childNodes).map(deserialize)

    switch (el.nodeName) {
        case 'BODY':
            return jsx('fragment', {}, children)
        case 'BR':
            return '\n'
        case 'BLOCKQUOTE':
            return jsx('element', { type: 'quote' }, children)
        case 'P':
            return jsx('element', { type: 'paragraph' }, children)
        case 'A':
            return jsx(
                'element',
                { type: 'link', url: el.getAttribute('href') },
                children
            )
        default:
            return el.textContent
    }
}

const popMsg = (msg: string) => {
    const args = {
        message: msg,
        description: '',
        icon: <SmileOutlined style={{ color: '#e1931e' }} />,
        duration: 3,
    }
    notification.open(args)
}

const plugs = { ...DefaultPlugin }
// 删除图片工具
Reflect.deleteProperty(plugs, 'ImgPlugin')

const MagicIconFont = () => (
    <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
        p-id="4297" width="1em" height="1em" fill="currentColor"
    >
        <path d="M615.915209 392.558677c-12.900821 0-23.421432-10.498098-23.421432-23.421432 0-64.541969-52.555983-117.099998-117.099998-117.099998-12.944823 0-23.419386-10.498098-23.419386-23.419386 0-12.922311 10.473539-23.421432 23.419386-23.421432 64.544015 0 117.099998-52.557006 117.099998-117.099998 0-12.921287 10.519588-23.419386 23.421432-23.419386 12.898775 0 23.420409 10.497075 23.420409 23.419386 0 64.542992 52.557006 117.099998 117.099998 117.099998 12.898775 0 23.420409 10.499122 23.420409 23.421432 0 12.921287-10.520611 23.419386-23.420409 23.419386-64.541969 0-117.099998 52.55803-117.099998 117.099998C639.334595 382.060579 628.813984 392.558677 615.915209 392.558677zM559.743886 228.616838c22.961968 13.858636 42.311665 33.163307 56.171324 56.170301 13.862729-22.960944 33.161261-42.310641 56.17337-56.170301-22.966061-13.859659-42.310641-33.163307-56.17337-56.171324C602.05555 195.408505 582.749856 214.757179 559.743886 228.616838z" p-id="4298"></path><path d="M147.512147 533.078061c-12.945847 0-23.419386-10.498098-23.419386-23.419386 0-12.922311-10.475586-23.420409-23.421432-23.420409-12.942777 0-23.419386-10.497075-23.419386-23.419386 0-12.922311 10.475586-23.421432 23.419386-23.421432 12.945847 0 23.421432-10.497075 23.421432-23.419386 0-12.923334 10.473539-23.419386 23.419386-23.419386s23.421432 10.496052 23.421432 23.419386c0 12.922311 10.473539 23.419386 23.419386 23.419386s23.418362 10.498098 23.418362 23.421432c0 12.922311-10.472516 23.419386-23.418362 23.419386s-23.419386 10.498098-23.419386 23.420409C170.934602 522.578939 160.457993 533.078061 147.512147 533.078061z" p-id="4299"></path><path d="M927.235654 811.282271 431.436638 315.412646c-13.266142-13.265118-30.92329-20.514219-49.723471-20.514219s-36.45733 7.29515-49.720402 20.514219l-27.446096 27.445072c-13.266142 13.267165-20.49273 30.877241-20.49273 49.700959 0 18.821671 7.319709 36.433794 20.49273 49.697889l495.892137 495.824599c13.264095 13.264095 30.832216 20.537755 49.677423 20.537755 18.84623 0 36.407188-7.27366 49.677423-20.537755l27.442002-27.447119c13.268188-13.264095 20.537755-30.829146 20.537755-49.674353C947.77341 842.11244 940.503842 824.548412 927.235654 811.282271zM337.753979 375.976l27.446096-27.446096c4.39203-4.412496 10.247388-6.792707 16.558118-6.792707 6.312776 0 12.169157 2.424212 16.560164 6.792707l67.422575 67.403133-60.561307 60.563354-67.425645-67.402109C328.653717 399.968437 328.653717 385.100822 337.753979 375.976L337.753979 375.976zM894.120442 877.516788l-27.446096 27.444049c-4.435009 4.439102-10.293437 6.816243-16.558118 6.816243-6.265704 0-12.169157-2.422166-16.558118-6.816243L438.296883 509.703701l60.563354-60.562331 395.260206 395.257136C903.269823 853.549933 903.269823 868.415502 894.120442 877.516788L894.120442 877.516788z" p-id="4300"></path><path d="M241.193783 298.877041c-12.945847 0-23.422456-10.498098-23.422456-23.418362 0-38.745443-31.513738-70.26225-70.25918-70.26225-12.945847 0-23.419386-10.496052-23.419386-23.419386 0-12.922311 10.473539-23.421432 23.419386-23.421432 38.745443 0 70.25918-31.515784 70.25918-70.260204 0-12.921287 10.475586-23.419386 23.422456-23.419386 12.944823 0 23.419386 10.497075 23.419386 23.419386 0 38.743396 31.515784 70.260204 70.260204 70.260204 12.9438 0 23.419386 10.498098 23.419386 23.421432 0 12.923334-10.475586 23.419386-23.419386 23.419386-38.744419 0-70.260204 31.516808-70.260204 70.26225C264.613168 288.378943 254.139629 298.877041 241.193783 298.877041zM217.681276 181.777043c8.92016 6.700609 16.788361 14.614859 23.51353 23.51046 6.723122-8.895601 14.591323-16.809851 23.51046-23.51046-8.919137-6.701632-16.787338-14.614859-23.51046-23.511483C234.469638 167.162184 226.601436 175.075411 217.681276 181.777043z" p-id="4301"></path><path d="M241.193783 767.279081c-12.945847 0-23.422456-10.519588-23.422456-23.420409 0-38.743396-31.513738-70.260204-70.25918-70.260204-12.945847 0-23.419386-10.521634-23.419386-23.421432 0-12.899798 10.473539-23.418362 23.419386-23.418362 38.745443 0 70.25918-31.516808 70.25918-70.26225 0-12.920264 10.475586-23.419386 23.422456-23.419386 12.944823 0 23.419386 10.499122 23.419386 23.419386 0 38.745443 31.515784 70.26225 70.260204 70.26225 12.9438 0 23.419386 10.517541 23.419386 23.418362 0 12.898775-10.475586 23.421432-23.419386 23.421432-38.744419 0-70.260204 31.516808-70.260204 70.260204C264.613168 756.759493 254.139629 767.279081 241.193783 767.279081zM217.681276 650.177036c8.92016 6.678096 16.788361 14.639418 23.51353 23.511483 6.723122-8.872065 14.591323-16.832364 23.51046-23.511483-8.919137-6.67605-16.787338-14.636349-23.51046-23.51046C234.469638 635.541711 226.601436 643.500986 217.681276 650.177036z"
            p-id="4302"></path>
    </svg>
)

const Table1Edit: FC = () => {
    const dispatch = useDispatch()
    const locationObj = useLocation()
    const { t, i18n } = useTranslation()
    const history: any = useHistory()
    const route = useSelector((state: IAppState) => state.router)
    const workgroupList = useSelector((state: IAppState) => state.tableEditData.workgroupList)
    const tableEditData = useSelector((state: IAppState) => state.tableEditData.table2EditData)
    const dicClassList = useSelector((state: IAppState) => state.tableEditData.dicClass)
    const authInfo = useSelector((state: IAppState) => state.auth.authInfo)

    const formRef = createRef<FormInstance>()
    const editorRef = useRef<DSlateRef>(null)
    const editorRef2 = useRef<DSlateRef>(null)
    const editorRef3 = useRef<DSlateRef>(null)
    const locationSearch = useRef<{
        workGroupId: number | undefined
        projectInfoId: number | undefined
        parentId: number | undefined
        techOnlineReviewId: number | undefined
    }>({
        workGroupId: undefined,
        projectInfoId: undefined,
        parentId: undefined,
        techOnlineReviewId: undefined
    })
    const { Text } = Typography
    const { Option } = Select
    const { TextArea } = Input
    // const { Dragger } = Upload
    const [isInit, setIsInit] = useState(true)
    const [isInit2, setIsInit2] = useState(true)
    const [isInit3, setIsInit3] = useState(true)
    const [loading, setLoading] = useState(false)
    const [editorKey, setEditorKey] = useState<string[]>(['1', '2', '3'])
    const [years, setYears] = useState<string[]>([])
    const [classification, setClassification] = useState<IClassification[]>([])
    // 年 选了3个季度后，则不能再选，选了 on 以后，后面的不能再选 plan
    // 缓存每一个选了的数据
    const [yearSelects, setYearSelects] = useState<{
        [props: string]: IYearSelect
    }>({})
    // 选了的年-季度名称
    const [yearSelectsFields, setYearSelectsFields] = useState<string[]>([])
    const [showAddYear, setShowAddYear] = useState<boolean>(false)
    // 根据 TMT Approval 是否为 PASSED 来决定后续填写项是否必填
    const [isPassed, setIsPassed] = useState(false)
    // 根据 TMT Approval 是否为 BU's NEEDS 来决定是否填写【ALM需求编号】
    const [isBuNeeds, setIsBuNeeds] = useState(false)
    const [prodList, setProdList] = useState<any[]>([])
    const [projectInfo, setProjectInfo] = useState<any>(null)
    // 相关BU
    const [buAttr, setBuAttr] = useState<IBu[]>([])
    // 开发责任主体
    const [dutyBuss, setDutyBuss] = useState<IBu[]>([])
    // 选择BU或CT清单
    const [showSelectBu, setShowSelectBu] = useState(false)
    const [showSelectBu2, setShowSelectBu2] = useState(false)
    const [showSelectProjects, setShowSelectProjects] = useState(false)
    // 自动生成名称
    const [generalNameField, setGeneralNameField] = useState('')
    const [generalLoading, setGeneralLoading] = useState({
        techName: false,
        subsidiary: false,
        description: false,
        quantitativeIndicators: false
    })
    const [curWorkgroup, setCurWorkgroup] = useState<{
        id: number
        groupName: string
    } | undefined>(undefined)
    const [descriptionValue, setDescriptionValue] = useState<Descendant[]>([
        {
            type: 'paragraph',
            children: [{ text: '' }],
        },
    ])
    const [descriptionValue2, setDescriptionValue2] = useState<Descendant[]>([
        {
            type: 'paragraph',
            children: [{ text: '' }],
        },
    ])
    const [descriptionValue3, setDescriptionValue3] = useState<Descendant[]>([
        {
            type: 'paragraph',
            children: [{ text: '' }],
        },
    ])
    const [editorHtml, setEditorHtml] = useState<{ __html: string }>()
    const [techNameVoli, setTechNameVoli] = useState<{
        help: string
        validateStatus: ValidateStatus | undefined
    }>({
        help: '',
        validateStatus: undefined
    })
    const [descVoli, setDescVoli] = useState<{
        help: string
        validateStatus: ValidateStatus | undefined
    }>({
        help: '',
        validateStatus: undefined
    })
    const [quantitativeIndicatorsVoli, setQuantitativeIndicatorsVoli] = useState<{
        help: string
        validateStatus: ValidateStatus | undefined
    }>({
        help: '',
        validateStatus: undefined
    })
    const [isView, setIsView] = useState(false)

    const layout = {
        labelCol: { span: 8 },
        wrapperCol: { span: 14 },
    }
    const tailLayout = {
        wrapperCol: { offset: 8, span: 10 },
    }

    const onFinish = async (values: any) => {
        console.log('onFinish: ', values)
        const findObj = yearSelectsFields.find(item => yearSelects[item].validateStatus)
        if (findObj) {
            return onFinishFailed({ errorFields: yearSelectsFields })
        }
        // 两个季度也要判断是否连续
        if (yearSelectsFields.length === 2) {
            const isContinuityResult = isContinuity(yearSelectsFields[1], yearSelectsFields[0])
            if (!isContinuityResult) {
                return popMsg(t('errorMessageContinuity'))
            }
        }
        // 技术名
        const editorHtmlValue = editorRef.current?.serialize({ children: serialize(handleTrim(descriptionValue)) })
        // 说明
        const description = editorRef2.current?.serialize({ children: serialize(handleTrim(descriptionValue2)) })
        // 量化指标
        const quantitativeIndicators = editorRef3.current?.serialize({ children: serialize(handleTrim(descriptionValue3)) })
        editorHtmlValue && setEditorHtml({
            __html: editorHtmlValue
        })
        const formData = {
            ...values,
            isMajorProject: values.isMajorProject === 1,
            deliveryReview: isBuNeeds ? "BU's NEEDS" : '',
            resourceNeeded: values.resourceNeeded ? +values.resourceNeeded : undefined,
            techName: JSON.stringify({
                str: editorHtmlValue,
                obj: handleTrim(descriptionValue)
            }),
            description: JSON.stringify({
                str: description,
                obj: descriptionValue2
            }),
            quantitativeIndicators: JSON.stringify({
                str: quantitativeIndicators,
                obj: handleTrim(descriptionValue3)
            }),
            buStakeholder: values.buStakeholder?.join(',') || '',
            techYearQuarters: [],
            project: values.projectNo ? {
                id: values.projectId,
                projectNo: values.projectNo,
                projectName: values.projectName,
                approvalDate: values.approvalDate,
                estimateClosedDate: values.estimateClosedDate,
                actualClosedDate: values.actualClosedDate,
                projectResult: values.projectResult
            } : undefined,
            patent: values.patentCode ? {
                id: values.patentId,
                patentCode: values.patentCode,
                patentNum: values.patentNum,
                patentStatus: values.patentStatus,
            } : undefined
        }

        // eslint-disable-next-line no-constant-condition
        // if (1) {
        //     console.log('formData: ', formData)
        //     return
        // }
        // techYearQuarters
        for (let i = 0, len = yearSelectsFields.length; i < len; i++) {
            const techYearQuarter = []
            const key = yearSelectsFields[i]
            if (formData[key]) {
                techYearQuarter.push({
                    id: formData[`${key}id`] || null,
                    quarter: key.substring(4),
                    status: formData[key],
                    year: +(20 + key.substring(0, 2))
                })
            }
            if (techYearQuarter.length) {
                Array.prototype.push.apply(formData.techYearQuarters, techYearQuarter)
            }
        }
        try {
            setLoading(true)
            if (!(locationObj.pathname === '/projectInfoEdit' && tableEditData.id)) {
                await addProjectInfo(formData).finally(() => {
                    setLoading(false)
                })
            } else {
                await editProjectInfo(formData).finally(() => {
                    setLoading(false)
                })
            }
            const args = {
                message: t('save') + (i18n.language !== 'zh' ? ' ' : '') + t('success'),
                description: '',
                icon: <CheckCircleOutlined style={{ color: '#08993f' }} />,
                duration: 3,
            }
            notification.open(args)
            if (locationObj.key) {
                history.goBack()
                // dispatch(goBack())
            } else {
                history.replace('/indexPage')
            }
        } catch (error: any) {
            const str = getErrorStr(error)
            dispatch(requestFail(str))
        }
    }
    const onFinishFailed = ({ errorFields }: { errorFields: any}) => {
        console.log('onFinishFailed: ', errorFields)
        if (errorFields.length) {
            popMsg(t('FinishFailed'))
        }
    }
    const onReset = () => {
        formRef.current?.resetFields()
        setYearSelects({})
        setYearSelectsFields([])
        setTechNameVoli({
            help: '',
            validateStatus: undefined
        })
        setDescVoli({
            help: '',
            validateStatus: undefined
        })
        setQuantitativeIndicatorsVoli({
            help: '',
            validateStatus: undefined
        })
        setDescriptionValue([
            {
                type: 'paragraph',
                children: [{ text: '' }],
            },
        ])
        setDescriptionValue2([
            {
                type: 'paragraph',
                children: [{ text: '' }],
            },
        ])
        setDescriptionValue3([
            {
                type: 'paragraph',
                children: [{ text: '' }],
            },
        ])
    }

    // 判断是否连续选择季度，与上一个季度对比
    const isContinuity = (cur: string, prev: string) => {
        const arr = ['Q1', 'Q2', 'Q3', 'Q4']
        // 选项的季度位置
        let loc: number = arr.indexOf(cur.substring(3))
        const preLoc: number = arr.indexOf(prev.substring(3))
        const curYear = +(cur.substring(0, 2))
        const prevYear = +(prev.substring(0, 2))
        if (curYear === prevYear) {
            loc--
            if (loc === -1) {
                loc = 0
            }
            if (loc === preLoc) {
                return true
            }
            return false
        } else if (prevYear === curYear - 1) {
            return loc === 0 && preLoc === 3
        } else {
            return false
        }
    }
    // 判断是否是选了 ON 的后面选项
    const isYearQuarterAfter = (year: string, quarter: number) => {
        const _year = +(year.substring(2))
        // // 是否有选 ON 的选项
        const len = yearSelectsFields.length
        for (let i = 0; i < len; i++) {
            const item = yearSelectsFields[i]
            // 找到第一个选 ON 的项，然后判断是否该选项的后续
            if (yearSelects[item].value === 2) {
                const findYear = +item.substring(0, 2)
                const findQuarter = +item.substring(4)
                if (_year < findYear) {
                    return false
                }
                if (_year > findYear) {
                    return true
                }
                if (_year === findYear) {
                    return quarter > findQuarter
                }
            }
        }
        return false
    }
    const setYearQuarterVoli = ({ techYearQuarters, year, quarter, value }: {
        techYearQuarters?: ITechYearQuarters[]
        year?: string
        quarter?: number
        value?: number
    }) => {
        const _yearSelectsFields: string[] = [...yearSelectsFields]
        const _yearSelects: {
            [props: string]: IYearSelect
        } = {}
        for (const key in yearSelects) {
            _yearSelects[key] = {
                value: yearSelects[key].value
            }
        }
        const yearQuarterStr = `${year?.substring(2)}-Q${(quarter || 0) + 1}`
        // 编辑时初始带过来
        if (techYearQuarters) {
            for (let i = 0, len = techYearQuarters.length; i < len; i++) {
                const yearItem = techYearQuarters[i]
                const _yearQuarterStr = `${String(yearItem.year).substring(2)}-Q${yearItem.quarter}`
                // 是否连续、超过3个、ON 后面有 PLAN 选项
                _yearSelects[_yearQuarterStr] = {
                    value: yearItem.status
                }
                if (!_yearSelectsFields.includes(_yearQuarterStr)) {
                    _yearSelectsFields.push(_yearQuarterStr)
                }
            }
        } else if (!value) {
            // 清空时，_yearSelectsFields 中去掉该年季度
            const curIndex = _yearSelectsFields.findIndex(item => item === yearQuarterStr)
            Reflect.deleteProperty(_yearSelects, _yearSelectsFields[curIndex])
            _yearSelectsFields.splice(curIndex, 1)
        } else {
            // 选择切换时
            if (!_yearSelectsFields.includes(yearQuarterStr)) {
                _yearSelectsFields.push(yearQuarterStr)
            }
            for (let i = 0, len = _yearSelectsFields.length; i < len; i++) {
                const curYearQuarterStr = _yearSelectsFields[i]
                if (curYearQuarterStr === yearQuarterStr) {
                    _yearSelects[curYearQuarterStr] = {
                        value
                    }
                } else {
                    _yearSelects[curYearQuarterStr] = {
                        value: formRef.current?.getFieldValue(curYearQuarterStr)
                    }
                }
            }
        }
        _yearSelectsFields.sort()
        let firstONIndex = -1
        for (let i = 0, len = _yearSelectsFields.length; i < len; i++) {
            const _yearQuarterStr = _yearSelectsFields[i]
            if (_yearSelects[_yearQuarterStr].value === 2 && firstONIndex === -1) {
                firstONIndex = i
            }
            if (i > 0) {
                const prevYearQuarterStr = _yearSelectsFields[i - 1]
                // 是否超过3个
                if (i > 2) {
                    _yearSelects[_yearQuarterStr].validateStatus = ValidateStatus.ERROR
                    _yearSelects[_yearQuarterStr].message = t('max3Quarters')
                }
                // 判断是否连续，与上一个选项对比
                if (_yearSelectsFields.length > 2) {
                    if (!isContinuity(_yearQuarterStr, prevYearQuarterStr)) {
                        _yearSelects[_yearQuarterStr].validateStatus = ValidateStatus.ERROR
                        _yearSelects[_yearQuarterStr].message = t('errorMessageContinuity')
                    }
                }
                // 判断是否 ON 后面有 PLAN 选项
                if (firstONIndex !== -1 && i > firstONIndex && _yearSelects[_yearQuarterStr].value === 1) {
                    _yearSelects[_yearQuarterStr].validateStatus = ValidateStatus.ERROR
                    _yearSelects[_yearQuarterStr].message = t('afterOnNotPlay')
                }
            }
        }
        setYearSelects(_yearSelects)
        setYearSelectsFields(_yearSelectsFields)
        return _yearSelects
    }
    // 选择了季度后，验证选项是否超过三个，连续，且 ON 后面没有 PLAN
    const onChangeSelectQuarter = (value: number, year: string, quarter: number) => {
        setYearQuarterVoli({ value, year, quarter })
        formRef.current?.validateFields(['years'])
    }

    // 获取课题信息
    const getTechDetail = async () => {
        const res = await getOnlineReviewById(locationSearch.current.techOnlineReviewId as number)
        console.log('res: ', res)
        let relevanceBussIds: any[] = []
        let dutyBussIds: any[] = []
        if (res.costBuss && res.costBuss.length > 0) {
            relevanceBussIds = res.costBuss.map(item => item.id)
            setBuAttr(res.costBuss)
        }
        if (res.dutyBuss && res.dutyBuss.length > 0) {
            dutyBussIds = res.dutyBuss.map(item => item.id)
            setDutyBuss(res.dutyBuss)
        }
        dispatch(setEdit2Data({
            id: undefined,
            version: 0,
            buStakeholder: undefined,
            description: res.description,
            developedBy: res.creator || '',
            techLevel: res.techLevel || 1,
            maturity: 'PLANNING',
            priority: 'HIGH',
            techMaturity: 'Prototype',
            quantitativeIndicators: '',
            requirementSource: '',
            researchForms: '',
            resourceNeeded: '',
            subsidiary: res.subsidiary,
            techClassId: '',
            classificationName: '',
            techName: res.proposalName,
            techPtn: '',
            tmtapproval: 'NO',
            toolsEquipment: '',
            isMajorProject: true,
            techYearQuarters: [],
            relevanceBuss: relevanceBussIds,
            dutyBuss: dutyBussIds,
        }))
    }
    // 获取所有分类
    const getClassAll = async (workGroupId: number) => {
        const data = await getTechClassificationListAll(workGroupId)
        setClassification(data)
    }
    // 获取 product list
    const getProductList = async (str?: string) => {
        const params: {
            pageNo: number
            pageSize: number
            platform?: string
        } = {
            pageNo: 1,
            pageSize: 10000
        }
        if (str) {
            params.platform = str
        }
        const res = await getProdList(params)
        setProdList(res.content)
    }
    // 选择BU/CT清单后
    const selectBuCallback = (res: IBu[]) => {
        const ids = res.map(item => item.id)
        formRef.current?.setFieldValue('relevanceBuss', ids)
        formRef.current?.validateFields(['relevanceBuss'])
        setBuAttr(res)
    }
    const selectBuCallback2 = (res: IBu[]) => {
        const ids = res.map(item => item.id)
        formRef.current?.setFieldValue('dutyBuss', ids)
        formRef.current?.validateFields(['dutyBuss'])
        setDutyBuss(res)
    }
    // 选择项目
    const onSelectProject = () => {
        setShowSelectProjects(true)
    }
    const clearProject = () => {
        const projectInfoObj = {
            projectName: '',
            projectNo: '',
            approvalDate: '',
            estimateClosedDate: '',
            actualClosedDate: '',
            projectResult: ''
        }
        formRef.current?.setFieldsValue(projectInfoObj)
        setProjectInfo(projectInfoObj)
    }
    const selectProjectCallBack = (projectInfo: any) => {
        const projectInfoObj = {
            projectName: projectInfo.projectName,
            projectNo: projectInfo.almProjectId,
            approvalDate: projectInfo.actualStartDate,
            estimateClosedDate: projectInfo.estimatedEndDate,
            actualClosedDate: projectInfo.actualEndDate,
            projectResult: projectInfo.finalResult
        }
        formRef.current?.setFieldsValue(projectInfoObj)
        setProjectInfo(projectInfoObj)
    }

    const handleGeneral = async (name: string) => {
        const formRefCache = formRef.current // 后面会丢失
        let validateValue: Record<string, any> = {}
        try {
            validateValue = await formRefCache?.validateFields(['techClassId'])
        } catch (e) {
            console.log('validate e: ', e)
            popMsg(t('FinishFailed'))
            setGeneralNameField('')
            setGeneralLoading({
                ...generalLoading,
                [name]: false
            })
        }
        if (!validateValue.techClassId) {
            return
        }
        const values = formRefCache?.getFieldsValue()
        // 技术名
        const techNameEditorHtmlValue = editorRef.current?.serialize({ children: serialize(handleTrim(descriptionValue)) })
        // 说明
        const descriptionEditorHtmlValue = editorRef2.current?.serialize({ children: serialize(handleTrim(descriptionValue2)) })
        // 量化指标
        const quantitativeIndicatorsEditorHtmlValue = editorRef3.current?.serialize({ children: serialize(handleTrim(descriptionValue3)) })
        const div = document.createElement('div')
        div.innerHTML = techNameEditorHtmlValue ?? ''
        const techName = div.innerText
        div.innerHTML = descriptionEditorHtmlValue ?? ''
        const description = div.innerText
        div.innerHTML = quantitativeIndicatorsEditorHtmlValue ?? ''
        const quantitativeIndicators = div.innerText
        const techClass = classification.find(classItem => classItem.id === values.techClassId)
        const formData = {
            techPtn: values.techPtn ?? '',
            techClass: techClass ?? {},
            researchForms: values.researchForms ?? '',
            techName,
            subsidiary: values.subsidiary ?? '',
            description,
            techLevel: values.techLevel ?? '',
            priority: values.priority ?? '',
            techYearQuarters: values.techYearQuarters ?? [],
            quantitativeIndicators,
            tmtapproval: values.tmtapproval ?? '',
            almCode: values.almCode ?? '',
            deliveryReview: values.deliveryReview ?? '',
            maturity: values.maturity ?? '',
            techMaturity: values.techMaturity ?? '',
            isMajorProject: values.isMajorProject === 1,
            requirementSource: values.requirementSource ?? '',
            developedBy: values.developedBy ?? '',
            toolsEquipment: values.toolsEquipment ?? '',
            platformIds: values.platformIds ?? [],
            buStakeholder: values.buStakeholder?.join(',') || '',
            relevanceBuss: values.relevanceBuss ?? '',
            dutyBuss: values.dutyBuss ?? '',
            resourceNeeded: values.resourceNeeded ? +values.resourceNeeded : undefined,
            planBudgeting: values.planBudgeting ?? '',
            budgeting: values.budgeting ?? '',
            project: values.projectNo ? {
                id: values.projectId,
                projectNo: values.projectNo,
                projectName: values.projectName,
                approvalDate: values.approvalDate,
                estimateClosedDate: values.estimateClosedDate,
                actualClosedDate: values.actualClosedDate,
                projectResult: values.projectResult
            } : undefined,
            patent: values.patentCode ? {
                id: values.patentId,
                patentCode: values.patentCode,
                patentNum: values.patentNum,
                patentStatus: values.patentStatus,
            } : undefined
        }
        let res = {
            data: ''
        }
        try {
            res = await getStandardName({
                query_key: name,
                json_data: formData,
                lang: i18n.language
            })
        } catch (error: any) {
            const str = getErrorStr(error)
            dispatch(requestFail(str))
        }
        console.log('res: ', res)
        const newKeys = [...editorKey]
        switch (name) {
            case 'techName':
                setDescriptionValue([
                    {
                        type: 'paragraph',
                        children: [{ text: res.data }],
                    },
                ])
                newKeys[0] = getUuid(8)
                setEditorKey(newKeys)
                break
            case 'subsidiary':
                formRefCache?.setFieldValue(name, res.data)
                break
            case 'description':
                setDescriptionValue2([
                    {
                        type: 'paragraph',
                        children: [{ text: res.data }],
                    },
                ])
                newKeys[1] = getUuid(8)
                setEditorKey(newKeys)
                break
            case 'quantitativeIndicators':
                setDescriptionValue3([
                    {
                        type: 'paragraph',
                        children: [{ text: res.data }],
                    },
                ])
                newKeys[2] = getUuid(8)
                setEditorKey(newKeys)
        }
        setGeneralNameField('')
        setGeneralLoading({
            ...generalLoading,
            [name]: false
        })
    }

    const voliForm = (field: string) => {
        formRef.current?.validateFields([field])
    }

    const [routes, setRoutes] = useState([
        {
            path: '/indexPage',
            breadcrumbName: t('indexPage'),
        },
        {
            path: '/projectInfo',
            breadcrumbName: 'Project Info ' + (i18n.language !== 'zh' ? ' ' : '') + t('list'),
        },
        {
            path: '/projectInfoEdit',
            breadcrumbName: tableEditData.id ? t('edit') : t('add'),
        },
    ])

    useEffect(() => {
        console.log('location: ', locationObj)
        const routeParams = new URLSearchParams(location.search)
        const worGroupIdParam = routeParams.get('workGroupId')
        const projectInfoId = routeParams.get('projectId')
        const parentId = routeParams.get('parentId') // 添加子课题
        const techOnlineReviewId = routeParams.get('techOnlineReviewId') // 提案申请通过，点击“创建课题”
        const _isView = routeParams.get('isView')
        if (_isView) {
            setIsView(!!_isView)
        }
        locationSearch.current = {
            workGroupId: +(worGroupIdParam || ''),
            projectInfoId: projectInfoId ? +projectInfoId : undefined,
            parentId: parentId ? +parentId : undefined,
            techOnlineReviewId: techOnlineReviewId ? +techOnlineReviewId : undefined
        }
        // 获取字典列表，作为下拉选项
        if (Object.keys(dicClassList).length === 0) {
            // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars, @typescript-eslint/no-empty-function
            getDicClass(dispatch, (a: boolean): void => {})
        }

        if (!workgroupList.length) {
            // 获取 workgroupList
            dispatch(getWorkgroup())
        }
        // 获取Project Info
        if (locationSearch.current.projectInfoId) {
            // 获取单据信息
            dispatch(getProjectInfoById({ projectInfoId: locationSearch.current.projectInfoId }))
        } else if (locationSearch.current.parentId) {
            // 添加子课题
            // 查询 parentId 对应的信息，显示父课题
            dispatch(getProjectInfoById({ projectInfoId: locationSearch.current.parentId }))
        // } else if (locationObj.pathname.includes('Add')) {
            // 新增时清空表单
            // onReset()
        }

        // 获取 product list
        getProductList()
        // 获取技术分类
        // dispatch(getTechClassification({
        //     workGroupId: locationSearch.current.workGroupId as number
        // }))
        // 获取课题信息
        if (locationSearch.current.techOnlineReviewId) {
            getTechDetail()
        }
        // 获取所有分类
        getClassAll(locationSearch.current.workGroupId as number)
    }, [])
    useEffect(() => {
        const formData = { ...tableEditData }
        console.log('formData: ', formData)
        if (locationSearch.current.workGroupId) {
            const findObj = workgroupList.find(item => item.id === locationSearch.current.workGroupId)
            setCurWorkgroup(findObj)
            const _routes = [...routes]
            const routerLen = _routes.length
            if (findObj) {
                _routes[_routes.length - 2].breadcrumbName = findObj.groupName
                _routes[_routes.length - 2].path = `/projectInfo?workGroupId=${findObj.id}`
            }
            if (locationObj.search.includes('parentId')) {
                _routes[_routes.length - 1].breadcrumbName = t('addSubTech')
            }
            setRoutes(_routes)
            if (locationObj.pathname === '/projectInfoView') {
                _routes[routerLen - 1].breadcrumbName = t('view')
            }
            formData.workgroupId = locationSearch.current.workGroupId
        }

        const _editorKey = [getUuid(8), getUuid(8), getUuid(8)]
        setEditorKey(_editorKey)
        setIsPassed(formData.tmtapproval === 'PASSED')
        // 编辑状态
        if (!(locationObj.pathname.includes('Add'))) {
            // 获取保存的原数据对象进行回显
            if (tableEditData.techName) {
                setDescriptionValue(JSON.parse(tableEditData.techName).obj)
            }
            if (tableEditData.description) {
                setDescriptionValue2(JSON.parse(tableEditData.description).obj)
            }
            if (tableEditData.quantitativeIndicators) {
                setDescriptionValue3(JSON.parse(tableEditData.quantitativeIndicators).obj)
            }
            // 初始化读取年、季度数据，并设置验证状态
            const yearQuarterValue: Record<string, any> = {}
            if (tableEditData.techYearQuarters && tableEditData.techYearQuarters.length) {
                tableEditData.techYearQuarters.sort((a, b) => a.quarter - b.quarter)
                tableEditData.techYearQuarters.sort((a, b) => a.year - b.year)
                const yearList = new Set(tableEditData.techYearQuarters.map(yearItem => '' + yearItem.year))
                setYears([...yearList])
                // 设置验证状态
                const _yearSelects = setYearQuarterVoli({ techYearQuarters: tableEditData.techYearQuarters })
                // 设置年、季度值
                for (const key in _yearSelects) {
                    yearQuarterValue[key] = _yearSelects[key].value
                }
                // const html = `<p>An opening paragraph with a <a href="https://example.com">link</a> in it.</p>
                // <blockquote><p>A wise quote.</p></blockquote>
                // <p>A closing paragraph!</p>`
                // const techName = new DOMParser().parseFromString(html, 'text/html')
                // const techName = new DOMParser().parseFromString(tableEditData.techName, 'text/html')
            }
            setBuAttr(formData.relevanceBuss)
            setDutyBuss(formData.dutyBuss)
            setIsBuNeeds(formData.tmtapproval === "BU's NEEDS")
            formRef.current?.setFieldsValue({
                ...formData,
                isMajorProject: formData.isMajorProject ? 1 : 0,
                ...yearQuarterValue,
                platformIds: formData.platforms ? formData.platforms.map((item: any) => item.id) : [],
                dutyBuss: formData.dutyBuss ? formData.dutyBuss.map((item: any) => item.id) : [],
                relevanceBuss: formData.relevanceBuss ? formData.relevanceBuss.map((item: any) => item.id) : [],
                buStakeholder:  formData.buStakeholder ? formData.buStakeholder.split(',') : [],
            })
            setProjectInfo({
                projectNo: formData.projectNo,
                projectName: formData.projectName,
                approvalDate: formData.approvalDate,
                estimateClosedDate: formData.estimateClosedDate,
                actualClosedDate: formData.actualClosedDate,
                projectResult: formData.projectResult
            })
        } else if (locationSearch.current.parentId) {
            // 获取保存的原数据对象进行回显
            if (formData.techName) {
                setDescriptionValue(JSON.parse(formData.techName).obj)
            }
            if (formData.description) {
                setDescriptionValue2(JSON.parse(formData.description).obj)
            }
            if (formData.quantitativeIndicators) {
                setDescriptionValue3(JSON.parse(formData.quantitativeIndicators).obj)
            }
            // 初始化读取年、季度数据，并设置验证状态
            const yearQuarterValue: Record<string, any> = {}
            if (formData.techYearQuarters && formData.techYearQuarters.length) {
                formData.techYearQuarters.sort((a, b) => a.quarter - b.quarter)
                formData.techYearQuarters.sort((a, b) => a.year - b.year)
                const yearList = new Set(formData.techYearQuarters.map(yearItem => '' + yearItem.year))
                setYears([...yearList])
                // 设置验证状态
                const _yearSelects = setYearQuarterVoli({ techYearQuarters: formData.techYearQuarters })
                // 设置年、季度值
                for (const key in _yearSelects) {
                    yearQuarterValue[key] = _yearSelects[key].value
                }
            }
            // 设置 parentId
            // 带入父级基础信息 除子技术、TMT评审及后面的不带
            formRef.current?.setFieldsValue({
                parentId: locationSearch.current.parentId,
                techClassId: formData.techClassId,
                researchForms: formData.researchForms,
                techLevel: formData.techLevel,
                priority: formData.priority,
                ...yearQuarterValue
            })
            // setProjectInfo({
            //     projectNo: formData.projectNo,
            //     projectName: formData.projectName,
            //     approvalDate: formData.approvalDate,
            //     estimateClosedDate: formData.estimateClosedDate,
            //     actualClosedDate: formData.actualClosedDate,
            //     projectResult: formData.projectResult
            // })
        } else if (locationSearch.current.techOnlineReviewId) {
            // 提案申请通过，点击“创建课题”
            console.log('tableEditData: ', tableEditData)
            if (tableEditData.techName && tableEditData.techName.includes('str') && tableEditData.techName.includes('obj')) {
                setDescriptionValue(JSON.parse(tableEditData.techName).obj)
            } else {
                setDescriptionValue([
                    {
                        type: 'paragraph',
                        children: [{ text: tableEditData.techName ? tableEditData.techName : '' }],
                    },
                ])
            }
            if (tableEditData.description && tableEditData.description.includes('str') && tableEditData.description.includes('obj')) {
                const descriptionObj = JSON.parse(tableEditData.description)
                console.log('descriptionObj: ', descriptionObj)
                if (JSON.stringify(descriptionObj.obj) === '[{"type":"paragraph","children":[{"text":""}]}]') {
                    let descriptionT = delHtmlTag(descriptionObj.str)
                    descriptionT = descriptionT.replace(/&nbsp;/ig, '')
                    console.log('descriptionT: ', descriptionT)
                    setDescriptionValue2([{ 'type':'paragraph', 'children': [{ 'text': descriptionT }] }])
                } else {
                    setDescriptionValue2(JSON.parse(tableEditData.description).obj)
                }
            } else {
                setDescriptionValue2([
                    {
                        type: 'paragraph',
                        children: [{ text: tableEditData.description ? tableEditData.description : '' }],
                    },
                ])
            }
            formRef.current?.setFieldsValue({
                ...tableEditData,
                techOnlineReviewId: locationSearch.current.techOnlineReviewId,
                isMajorProject: formData.isMajorProject ? 1 : 0,
                dutyBuss: formData.dutyBuss,
                relevanceBuss: formData.relevanceBuss,
            })
            setProjectInfo({
                projectNo: tableEditData.projectNo,
                approvalDate: tableEditData.approvalDate,
                estimateClosedDate: tableEditData.estimateClosedDate,
                actualClosedDate: tableEditData.actualClosedDate,
                projectResult: tableEditData.projectResult
            })
        }
    }, [workgroupList, tableEditData])
    useEffect(() => {
        // 不设置值验证会报错
        formRef.current?.setFieldValue('techName', 111)
        if (isInit) {
            setIsInit(false)
        } else {
            formRef.current?.validateFields(['techName'])
        }
    }, [descriptionValue])
    useEffect(() => {
        // 不设置值验证会报错
        formRef.current?.setFieldValue('description', 111)
        if (isInit2) {
            setIsInit2(false)
        } else {
            formRef.current?.validateFields(['description'])
        }
    }, [descriptionValue2])
    useEffect(() => {
        // 不设置值验证会报错
        formRef.current?.setFieldValue('quantitativeIndicators', 111)
        if (isInit3) {
            setIsInit3(false)
        } else {
            formRef.current?.validateFields(['quantitativeIndicators'])
        }
    }, [descriptionValue3])
    useEffect(() => {
        const _routes = routes.slice(0)
        const routerLen = _routes.length
        if (isView) {
            _routes[routerLen - 1].breadcrumbName = t('view')
        } else if (locationObj.search.includes('parentId')) {
            _routes[routerLen - 1].breadcrumbName = t('addSubTech')
        } else {
            _routes[routerLen - 1].breadcrumbName = tableEditData.id ? t('edit') : t('add')
        }
        setRoutes(_routes)
    }, [i18n.language])
    useEffect(() => {
        if (generalNameField !== '' && generalNameField in generalLoading) {
            setGeneralLoading({
                ...generalLoading,
                [generalNameField]: true
            })
            handleGeneral(generalNameField)
        }
    }, [generalNameField])
    return (
        <Space direction="vertical" size={10} style={{ width: '100%' }}>
            <Nav dispatch={dispatch} />
            <PageBreadcrumb routerParam={routes}
                history={history}
                route={route}
                dispatch={dispatch}
            />
            <Form {...layout} ref={formRef} name="control-ref"
                style={{ paddingLeft: 20, paddingRight: 20 }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                className="edit_table"
            >
                <Form.Item name="id" hidden><Input /></Form.Item>
                <Form.Item name="version" hidden><Input /></Form.Item>
                <Form.Item name="techClassId" hidden><Input /></Form.Item>
                <Form.Item name="techOnlineReviewId" hidden><Input /></Form.Item>
                <Row>
                    <Col span={12}>
                        <Form.Item name="workgroupId" label={<span className='label'>{t('Work Group')}</span>}
                            style={{ marginBottom: 5 }}
                        >
                            {/* <Select allowClear placeholder='请选择 workgroup'
                            onChange={e => {
                                if (e) {
                                    setSelectWorkgroup(e)
                                    // 获取 classificationList
                                    dispatch(getTechClassification({
                                        workGroupId: e
                                    }))
                                    formRef.current?.setFieldValue('techClassId', null)
                                }
                            }}
                        >
                            {
                                workgroupList.map(item => {
                                    return <Option key={item.id} value={item.id}>{item.groupName}</Option>
                                })
                            }
                        </Select> */}
                            { curWorkgroup && curWorkgroup?.groupName }
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        {/* 添加子课题时，传入父课题 id */}
                        {locationSearch.current.parentId ?
                            <>
                                <Form.Item name="parentId" hidden><Input /></Form.Item>
                                <Form.Item label={t('parentTech')} style={{ marginBottom: 5 }}>
                                    <div dangerouslySetInnerHTML={{
                                        __html: tableEditData.techName ? JSON.parse(tableEditData.techName).str : ''
                                    }}></div>
                                </Form.Item>
                            </> : <></>
                        }
                    </Col>
                    <Col span={12}>
                        {!((locationObj.pathname === '/projectInfoView') && tableEditData.id)
                            ? (
                                <Form.Item name="techClassId"
                                    label={<span className='label'>{t('Classification')}</span>}
                                    rules={[{ required: true, message: t('Classification Required') }]}
                                >
                                    <Select allowClear placeholder={t('Classification Placeholder')}>
                                        {
                                            // groupByClassification(classification).map(item => (
                                            classification.map(item => (
                                                <Option key={item.id} value={item.id} title={item.classificationName}>
                                                    {item.classificationName}
                                                </Option>
                                            ))
                                        }
                                    </Select>
                                </Form.Item>
                            )
                            : (
                                <Form.Item label={<span className='label'>{t('Classification')}</span>}>
                                    {tableEditData.classificationName}
                                </Form.Item>
                            )
                        }
                    </Col>
                    <Col span={12}>
                        {
                            (locationSearch.current.projectInfoId && tableEditData.id) ? (
                                <Form.Item name="techPtn" label={<span className='label'>{t('PTN')}</span>}
                                    style={{ marginBottom: 0 }}
                                >
                                    <Text style={{ fontSize: 14 }}>{tableEditData.techPtn}</Text>
                                    {/* <Space>
                                        {tableEditData.key || 'PTNSNA21001'}
                                        {!tableEditData.key && (<Text disabled style={{ fontSize: 12 }}>* 后台自动生成</Text>)}
                                    </Space> */}
                                </Form.Item>
                            ) : null
                        }
                    </Col>
                </Row>
                <Space direction="vertical" size={0}
                    className='form_item_mb'
                    style={{ width: '100%' }}
                >
                    <Form.Item name="projectId" hidden>
                        <Input />
                    </Form.Item>
                    <Form.Item name="projectName" hidden>
                        <Input />
                    </Form.Item>
                    <Row>
                        {isView ? <>
                            <Col span={12}>
                                <Form.Item name="projectName"
                                    label={<span className='label'>{t('projectName')}</span>}
                                >
                                    <span>{projectInfo?.projectName}</span>
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item name="approvalDate"
                                    label={<span className='label'>{t('approvalDate')}</span>}
                                >
                                    {projectInfo?.approvalDate || ''}
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item name="estimateClosedDate"
                                    label={<span className='label'>{t('estimateClosedDate')}</span>}
                                >
                                    {projectInfo?.estimateClosedDate || ''}
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item name="actualClosedDate"
                                    label={<span className='label'>{t('actualClosedDate')}</span>}
                                >
                                    {projectInfo?.actualClosedDate || ''}
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item name="projectResult"
                                    label={<span className='label'>{t('projectResult')}</span>}
                                >
                                    {projectInfo?.projectResult || ''}
                                </Form.Item>
                            </Col>
                        </>
                            : (authInfo && Reflect.has(authInfo, 'selectProject') && <>
                                <Form.Item name="projectNo" hidden>
                                    <Input />
                                </Form.Item>
                                <Col span={12}>
                                    <Form.Item name="projectName"
                                        label={<span className='label'>{t('projectName')}</span>}
                                    >
                                        <>
                                            <Input hidden />
                                            <span style={{ marginRight: projectInfo?.projectNo ? 10 : 0 }}>{projectInfo?.projectName}</span>
                                            <Button
                                                onClick={onSelectProject}
                                            >{t('select') + (i18n.language !== 'zh' ? ' ' : '') + t('project')}</Button>
                                            {projectInfo?.projectNo && (<Button
                                                onClick={clearProject}
                                            >{t('reset') + (i18n.language !== 'zh' ? ' ' : '') + t('project')}</Button>)
                                            }
                                        </>
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item name="approvalDate"
                                        label={<span className='label'>{t('approvalDate')}</span>}
                                    >
                                        {projectInfo?.approvalDate || ''}
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item name="estimateClosedDate"
                                        label={<span className='label'>{t('estimateClosedDate')}</span>}
                                    >
                                        {projectInfo?.estimateClosedDate || ''}
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item name="actualClosedDate"
                                        label={<span className='label'>{t('actualClosedDate')}</span>}
                                    >
                                        {projectInfo?.actualClosedDate || ''}
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item name="projectResult"
                                        label={<span className='label'>{t('projectResult')}</span>}
                                    >
                                        {projectInfo?.projectResult || ''}
                                    </Form.Item>
                                </Col>
                            </>)
                        }
                    </Row>
                </Space>
                <Row>
                    <Col span={24}>
                        <Form.Item name="researchForms"
                            label={<span className='label'>{t('researchForms')}</span>}
                            labelCol={{ span: 4 }}
                            wrapperCol={{ span: 7 }}
                            rules={[{ required: true, message: t('researchForms Required') }]}
                        >
                            {isView
                                ? <span>{
                                    dicClassList['research form']
                            && dicClassList['research form'].find(item => item.value === tableEditData.researchForms)?.name
                                }</span>
                                : (<Select allowClear>
                                    {
                                        dicClassList['research form'] && dicClassList['research form'].map(item => (
                                            <Option value={item.value} key={item.value}>{item.name}</Option>
                                        ))
                                    }
                                </Select>)}
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <Form.Item name='techName'
                            label={<span className='label'>{t('Technology Name')}</span>}
                            labelCol={{ span: 4 }}
                            wrapperCol={{ span: 19 }}
                            className='editor_view'
                            help={techNameVoli.help}
                            validateStatus={techNameVoli.validateStatus}
                            rules={[
                                {
                                    required: true
                                },
                                {
                                    validator: async () => {
                                        if (JSON.stringify(descriptionValue) === '[{"type":"paragraph","children":[{"text":""}]}]') {
                                            const helpStr = t('Technology Name Required')
                                            setTechNameVoli({
                                                help: helpStr,
                                                validateStatus: ValidateStatus.ERROR
                                            })
                                            return Promise.reject(new Error(helpStr))
                                        } else {
                                            // 去掉前后空格
                                            const editorHtmlValue = editorRef.current?.serialize({ children: serialize(handleTrim(descriptionValue)) })
                                            // 获取去掉html后的纯文本
                                            const word = editorHtmlValue?.replace(/<[^>]*>/g, '')
                                            const errorStr = `${t('maxLenError')} 1000 ${t('lenCharError')}`
                                            if (word && word.length > 1000) {
                                                setTechNameVoli({
                                                    help: errorStr,
                                                    validateStatus: ValidateStatus.ERROR
                                                })
                                                return Promise.reject(new Error(errorStr))
                                            } else {
                                                setTechNameVoli({
                                                    help: '',
                                                    validateStatus: undefined
                                                })
                                                return Promise.resolve()
                                            }
                                        }
                                    }
                                }
                            ]}
                        >
                            <Input hidden />
                            {
                                isView
                                    ? (<div className='desc' dangerouslySetInnerHTML={{
                                        __html: tableEditData.techName ? JSON.parse(tableEditData.techName).str : ''
                                    }}></div>)
                                    : (<Space style={{ width: '100%', alignItems: 'flex-end' }}>
                                        <ConfigProvider
                                            value={{
                                                ...defaultConfig,
                                                plugins: [
                                                    ...Object.values({
                                                        ...plugs
                                                    }),
                                                ],
                                            }}
                                        >
                                            <DSlate ref={editorRef} key={editorKey[0]} value={descriptionValue} onChange={setDescriptionValue} />
                                        </ConfigProvider>
                                        {generalLoading.techName ? <LoadingOutlined style={{ fontSize: 20 }} />
                                            : <Icon component={MagicIconFont} style={{ fontSize: 20, color: '#2589cc', cursor: 'pointer' }}
                                                onClick={() => setGeneralNameField('techName')}
                                            />
                                        }
                                    </Space>)
                            }
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <Form.Item name="subsidiary" label={<span className='label'>{t('subsidiary')}</span>}
                            labelCol={{ span: 4 }}
                            wrapperCol={{ span: 19 }}
                            rules={[
                                {
                                    required: true,
                                    message: t('Please Input') + (i18n.language !== 'zh' ? ' ' : '') + t('subsidiary')
                                }
                            ]}
                        >
                            {isView ? <span>{tableEditData.subsidiary}</span> :
                                (<div style={{ display: 'flex', width: '100%', alignItems: 'flex-end', gap: 8 }}>
                                    <Form.Item name="subsidiary" style={{ flex: 1, marginBottom: 0 }}>
                                        {/* <NoSpaceInput maxLength={1000} allowClear /> */}
                                        <TextArea allowClear onChange={() => voliForm('subsidiary')} />
                                    </Form.Item>
                                    {generalLoading.subsidiary ? <LoadingOutlined style={{ fontSize: 20 }} />
                                        : <Icon component={MagicIconFont} style={{ fontSize: 20, color: '#2589cc', cursor: 'pointer' }}
                                            onClick={() => setGeneralNameField('subsidiary')}
                                        />
                                    }
                                </div>)
                            }
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <Form.Item name='description'
                            className={!isView ? 'editor_view' : ''}
                            label={<span className='label'>{t('description')}</span>}
                            labelCol={{ span: 4 }}
                            wrapperCol={{ span: 19 }}
                            help={descVoli.help}
                            validateStatus={descVoli.validateStatus}
                            rules={[
                                {
                                    required: true,
                                    validator: async () => {
                                        if (JSON.stringify(descriptionValue2) === '[{"type":"paragraph","children":[{"text":""}]}]') {
                                            const helpStr = t('Please Input') + (i18n.language !== 'zh' ? ' ' : '') + t('description')
                                            setDescVoli({
                                                help: helpStr,
                                                validateStatus: ValidateStatus.ERROR
                                            })
                                            return Promise.reject(new Error(helpStr))
                                        } else {
                                            const editorHtmlValue = editorRef.current?.serialize({ children: serialize(descriptionValue2) })
                                            // 获取去掉html后的纯文本
                                            const word = editorHtmlValue?.replace(/<[^>]*>/g, '')
                                            const errorStr = `${t('maxLenError')} 1000 ${t('lenCharError')}`
                                            if (word && word.length > 1000) {
                                                setDescVoli({
                                                    help: errorStr,
                                                    validateStatus: ValidateStatus.ERROR
                                                })
                                                return Promise.reject(new Error(errorStr))
                                            } else {
                                                setDescVoli({
                                                    help: '',
                                                    validateStatus: undefined
                                                })
                                                return Promise.resolve()
                                            }
                                        }
                                    }
                                }
                            ]}
                        >
                            <Input hidden />
                            {
                                isView
                                    ? (<div className='desc desc_break' dangerouslySetInnerHTML={{
                                        __html: tableEditData.description ? JSON.parse(tableEditData.description).str : ''
                                    }}></div>)
                                    : (<Space style={{ width: '100%', alignItems: 'flex-end' }}>
                                        <ConfigProvider
                                            value={{
                                                ...defaultConfig,
                                                plugins: [
                                                    ...Object.values({
                                                        ...plugs
                                                    }),
                                                ],
                                                customUploadRequest: ({ onSuccess, onProgress }) => {
                                                    onProgress?.({ percent: 10 })
                                                    setTimeout(() => {
                                                        onProgress?.({ percent: 50 })
                                                    }, 500)
                                                    setTimeout(() => {
                                                        // 这里模拟上传成功，传回一个URL
                                                        onSuccess?.({
                                                            url: `https://source.unsplash.com/300x200/?t=${new Date().valueOf()}`,
                                                        })
                                                    }, 1000)
                                                },
                                            }}
                                        >
                                            <DSlate ref={editorRef2} key={editorKey[1]} value={descriptionValue2} onChange={setDescriptionValue2} />
                                        </ConfigProvider>
                                        {generalLoading.description ? <LoadingOutlined style={{ fontSize: 20 }} />
                                            : <Icon component={MagicIconFont} style={{ fontSize: 20, color: '#2589cc', cursor: 'pointer' }}
                                                onClick={() => setGeneralNameField('description')}
                                            />
                                        }
                                    </Space>)
                            }
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <Form.Item name='quantitativeIndicators'
                            className='editor_view'
                            label={<span className='label'>{t('quantitativeIndicators')}</span>}
                            labelCol={{ span: 4 }}
                            wrapperCol={{ span: 19 }}
                            help={quantitativeIndicatorsVoli.help}
                            validateStatus={quantitativeIndicatorsVoli.validateStatus}
                            rules={[
                                {
                                    required: true,
                                    validator: async () => {
                                        if (JSON.stringify(descriptionValue3) === '[{"type":"paragraph","children":[{"text":""}]}]') {
                                            const helpStr = t('Please Input') + (i18n.language !== 'zh' ? ' ' : '') + t('quantitativeIndicators')
                                            setQuantitativeIndicatorsVoli({
                                                help: helpStr,
                                                validateStatus: ValidateStatus.ERROR
                                            })
                                            return Promise.reject(new Error(helpStr))
                                        } else {
                                            const editorHtmlValue = editorRef.current?.serialize({ children: serialize(handleTrim(descriptionValue3)) })
                                            // 获取去掉html后的纯文本
                                            const word = editorHtmlValue?.replace(/<[^>]*>/g, '')
                                            const errorStr = `${t('maxLenError')} 1000 ${t('lenCharError')}`
                                            if (word && word.length > 1000) {
                                                setQuantitativeIndicatorsVoli({
                                                    help: errorStr,
                                                    validateStatus: ValidateStatus.ERROR
                                                })
                                                return Promise.reject(new Error(errorStr))
                                            } else {
                                                setQuantitativeIndicatorsVoli({
                                                    help: '',
                                                    validateStatus: undefined
                                                })
                                                return Promise.resolve()
                                            }
                                        }
                                    }
                                }
                            ]}
                        >
                            <Input hidden />
                            {
                                isView
                                    ? (<div className='desc' dangerouslySetInnerHTML={{
                                        __html: tableEditData.quantitativeIndicators ? JSON.parse(tableEditData.quantitativeIndicators).str : ''
                                    }}></div>)
                                    : (<Space style={{ width: '100%', alignItems: 'flex-end' }}>
                                        <ConfigProvider
                                            value={{
                                                ...defaultConfig,
                                                plugins: [
                                                    ...Object.values({
                                                        ...plugs
                                                    }),
                                                ],
                                            }}
                                        >
                                            <DSlate ref={editorRef3} key={editorKey[2]} value={descriptionValue3} onChange={setDescriptionValue3} />
                                        </ConfigProvider>
                                        {generalLoading.quantitativeIndicators ? <LoadingOutlined style={{ fontSize: 20 }} />
                                            : <Icon component={MagicIconFont} style={{ fontSize: 20, color: '#2589cc', cursor: 'pointer' }}
                                                onClick={() => setGeneralNameField('quantitativeIndicators')}
                                            />
                                        }
                                    </Space>)
                            }
                        </Form.Item>
                    </Col>
                </Row>
                <Space direction="vertical" size={0}
                    className='form_item_mb'
                    style={{ width: '100%' }}
                >
                    <Row>
                        {/* 年 季度 列 */}
                        {isView
                            ? years.map(year => (
                                <Col span={12} key={year}>
                                    <Form.Item
                                        label={<span className='label'>{year + (i18n.language !== 'zh' ? ' ' : '') + t('year')}</span>}
                                        className='mb0'
                                    >
                                    </Form.Item>
                                    {tableEditData.techYearQuarters.map(yearItem => {
                                        if (yearItem.year === +year) {
                                            return (
                                                <Form.Item key={year + '-' + yearItem.quarter}
                                                    label={<span className='label'>{`${yearItem.quarter}${i18n.language !== 'zh' ? ' ' : ''}${t('quarter')}`}</span>}
                                                >
                                                    {/* {dicClassList['status-year']
                                                && dicClassList['status-year'].find(item => item.value === yearItem.status)?.name} */}
                                                    {['PLAN', 'ON'][yearItem.status - 1]}
                                                </Form.Item>
                                            )
                                        }
                                    })}
                                </Col>
                            ))
                            : years.map((year, index) => (
                                <Col span={12} key={year}>
                                    {/* 年 */}
                                    <Form.Item name={year}
                                        label={<span className='label'>{year + (i18n.language !== 'zh' ? ' ' : '') + t('year')}</span>}
                                        className='mb0 txt_right'
                                    >
                                        {/* 删除按钮 新增的可以删，已有id的读取出来的则不能删除 */}
                                        {/* (!tableEditData.techYearQuarters || tableEditData.techYearQuarters?.findIndex(yearItem => yearItem.year === +year) === -1) */}
                                        {
                                            <MinusCircleOutlined style={{ cursor: 'pointer', color: '#ff4d4f', fontSize: 20 }}
                                                onClick={() => {
                                                    years.splice(index, 1)
                                                    setYears([...years])
                                                    const _yearSelects = { ...yearSelects }
                                                    const _yearSelectsFields = [...yearSelectsFields]
                                                    // 清除验证状态
                                                    for (let i = 0; i < 4; i++) {
                                                        const _yearQuarterStr = `${year.substring(2)}-Q${i + 1}`
                                                        Reflect.deleteProperty(_yearSelects, _yearQuarterStr)
                                                        const strIndex = _yearSelectsFields.indexOf(_yearQuarterStr)
                                                        if (strIndex !== -1) {
                                                            _yearSelectsFields.splice(strIndex, 1)
                                                        }
                                                    }
                                                    setYearSelectsFields(_yearSelectsFields)
                                                    setYearSelects(_yearSelects)
                                                }}
                                            />
                                        }
                                    </Form.Item>
                                    {/* // 季度 */}
                                    {
                                        new Array(4).fill(1).map((_, quarter) => (
                                            <Fragment key={`${year}-${quarter + 1}id-${getUuid(8)}`}>
                                                <Form.Item name={`${year.substring(2)}-Q${quarter + 1}id`} hidden><Input /></Form.Item>
                                                <Form.Item name={`${year.substring(2)}-Q${quarter + 1}`}
                                                    label={<span className='label'>{`${quarter + 1}${i18n.language !== 'zh' ? ' ' : ''}${t('quarter')}`}</span>}
                                                    help={yearSelects[`${year.substring(2)}-Q${quarter + 1}`]?.validateStatus
                                                        ? yearSelects[`${year.substring(2)}-Q${quarter + 1}`]?.message
                                                        : ''
                                                    }
                                                    validateStatus={yearSelects[`${year.substring(2)}-Q${quarter + 1}`]?.validateStatus}
                                                    rules={[
                                                        {
                                                            validator: async (rule: any) => {
                                                                if (yearSelects[rule['fullField']]?.validateStatus) {
                                                                    return Promise.reject(new Error(yearSelects[rule['fullField']].message as string))
                                                                } else {
                                                                    return Promise.resolve()
                                                                }
                                                            }
                                                        }
                                                    ]}
                                                >
                                                    <Select allowClear
                                                        disabled={yearSelectsFields.length > 2
                                                    && yearSelectsFields.indexOf(`${year.substring(2)}-Q${quarter + 1}`) === -1
                                                        }
                                                        onChange={(value: number) => {
                                                            onChangeSelectQuarter(value, year, quarter)
                                                        }}
                                                    >
                                                        {/* 如果有一项选中 ON , 则后续不能选 PLAN */}
                                                        {/* 还要考虑选了后面的，再在前面选 ON, 此时需要把后面的一是要屏蔽 PLAN, 二是要把 PLAN 全部设为 ON */}
                                                        <Option value={1} disabled={isYearQuarterAfter(year, quarter + 1)}>PLAN</Option>
                                                        <Option value={2}>ON</Option>
                                                    </Select>
                                                </Form.Item>
                                            </Fragment>
                                        ))
                                    }
                                </Col>
                            ))
                        }
                    </Row>
                    <Row>
                        <Col span={12}>
                            <Form.Item name='years' label={<span className='label'>{t('add')}{i18n.language !== 'zh' ? ' ' : ''}{t('year')}</span>}
                                hidden={isView ? true : false}
                                rules={[
                                    {
                                        required: true,
                                        validator: async () => {
                                            console.log('years validate')
                                            const errorStr = t('years Required')
                                            if (yearSelectsFields.length === 0) {
                                                return Promise.reject(new Error(errorStr))
                                            } else {
                                            // formRef.current?.validateFields(yearSelectsFields)
                                                return Promise.resolve()
                                            }
                                        }
                                    }
                                ]}
                            >
                                <Input hidden />
                                {/* 新增时没有选择年时，才可以选择，不然只能递增 */}
                                {
                                    !years.length
                                        ? (
                                            <Popover visible={showAddYear} trigger="click"
                                                onVisibleChange={setShowAddYear}
                                                content={
                                                    <DatePicker allowClear picker="year"
                                                        placeholder={t('Please Select') + (i18n.language !== 'zh' ? ' ' : '') + t('year')}
                                                        disabledDate={current => {
                                                            let _year = new Date().getFullYear() - 1
                                                            if (years.length) {
                                                                _year = +years[years.length - 1] + 1
                                                            }
                                                            return current && current.year() < _year
                                                        }}
                                                        onChange={(date, dateString) => {
                                                            if (date) {
                                                                setYears([...years, dateString])
                                                                setShowAddYear(false)
                                                                const obj: Record<string, any> = {}
                                                                for (let i = 0; i < 4; i++) {
                                                                    const _yearQuarterStr = `${dateString.substring(2)}-Q${i + 1}`
                                                                    obj[_yearQuarterStr] = ''
                                                                }
                                                                formRef.current?.setFieldsValue(obj)
                                                            }
                                                        }}
                                                    />
                                                }
                                            >
                                                <PlusCircleOutlined style={{ fontSize: 30, cursor: 'pointer', color: '#1890ff' }} />
                                            </Popover>
                                        )
                                        : (
                                            <PlusCircleOutlined style={{ fontSize: 30, cursor: 'pointer', color: '#1890ff' }} onClick={() => {
                                                let addYear = new Date().getFullYear().toString()
                                                if (years.length === 0) {
                                                    setYears([addYear])
                                                } else {
                                                    addYear = '' + (+years[years.length - 1] + 1)
                                                    setYears([...years, addYear])
                                                }
                                                const obj: Record<string, any> = {}
                                                for (let i = 0; i < 4; i++) {
                                                    const _yearQuarterStr = `${addYear.substring(2)}-Q${i + 1}`
                                                    obj[_yearQuarterStr] = ''
                                                }
                                                formRef.current?.setFieldsValue(obj)
                                            }} />
                                        )
                                }
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={12}>
                            <Form.Item name="techLevel"
                                label={<span className='label'>{t('techLevel')}</span>}
                                rules={[{ required: true, message: t('techLevel Required') }]}
                            >
                                {isView
                                    ? (<span>{
                                        [t('core'), t('key'), t('general'), t('normal')][(tableEditData.techLevel as number) - 1]
                                    }</span>)
                                    : (<Select allowClear>
                                        <Option value={1}>{t('core')}</Option>
                                        <Option value={2}>{t('key')}</Option>
                                        <Option value={3}>{t('general')}</Option>
                                        <Option value={4}>{t('normal')}</Option>
                                    </Select>)}
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name="priority"
                                label={<span className='label'>{t('priority')}</span>}
                                rules={[{ required: true, message: t('priority Required') }]}
                            >
                                {isView
                                    ? <span>{
                                        dicClassList['priority'] &&
                                            dicClassList['priority'].find(item => item.value === tableEditData.priority)?.name
                                    }</span>
                                    : (<Select allowClear>
                                        {
                                            dicClassList['priority'] && dicClassList['priority'].map(item => (
                                                <Option value={item.value} key={item.value}>{item.name}</Option>
                                            ))
                                        }
                                    </Select>)}
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name="tmtapproval"
                                label={<span className='label'>{t('tmtApproval')}</span>}
                                rules={[{ required: true, message: t('tmtApproval Required') }]}
                            >
                                {isView
                                    ? <span>{
                                        dicClassList['tmt approval']
                                            && dicClassList['tmt approval'].find(item => item.value === tableEditData.tmtapproval)?.name
                                    }</span>
                                    : (<Select allowClear onChange={e => {
                                        setIsPassed(e === 'PASSED')
                                        setIsBuNeeds(e === "BU's NEEDS")
                                        formRef.current?.validateFields(['maturity', 'requirementSource',
                                            'developedBy', 'buStakeholder', 'toolsEquipment'])
                                    }}>
                                        {
                                            dicClassList['tmt approval'] && dicClassList['tmt approval'].map(item => (
                                            // BU's NEEDS 需要权限
                                                item.value !== "BU's NEEDS" || (item.value === "BU's NEEDS" && (authInfo && Reflect.has(authInfo, 'techDefineReview'))))
                                                ? <Option value={item.value} key={item.value}>{item.name}</Option>
                                                : <></>
                                            )
                                        }
                                    </Select>)
                                }
                            </Form.Item>
                        </Col>
                        {/* 选了 BU's NEEDS 后才显示 */}
                        {isBuNeeds && <Col span={12}>
                            <Form.Item name="almCode"
                                label={<span className='label'>{t('almCode')}</span>}
                            >
                                {isView
                                    ? <span>{tableEditData.almCode}</span>
                                    : <NoSpaceInput allowClear />
                                }
                            </Form.Item>
                        </Col>}
                        {/* 有值就显示值，没值就判断是否选了 BU's NEEDS, 选了则显示 BU's NEEDS，否则不显示 */}
                        {isView ? (<Col span={12}>
                            <Form.Item name="deliveryReview" label={<span className='label'>{t('techDeliveryReview')}</span>}>
                                <span>{tableEditData.deliveryReview}</span>
                            </Form.Item>
                        </Col>) : ((tableEditData.deliveryReview || isBuNeeds) && <Col span={12}>
                            <Form.Item name="deliveryReview" label={<span className='label'>{t('techDeliveryReview')}</span>}>
                                {tableEditData.deliveryReview || "BU's NEEDS"}
                            </Form.Item>
                        </Col>)}
                        {/* 技术状态 */}
                        <Col span={12}>
                            <Form.Item name="maturity"
                                label={<span className='label'>{t('maturity')}</span>}
                                rules={[{ required: isPassed, message: t('maturity Required') }]}
                            >
                                {isView
                                    ? <span>{
                                        dicClassList['maturity']
                                && dicClassList['maturity'].find(item => item.value === tableEditData.maturity)?.name
                                    }</span>
                                    : (<Select allowClear>
                                        {
                                            dicClassList['maturity'] && dicClassList['maturity'].map(item => (
                                                <Option value={item.value} key={item.value}>{item.name}</Option>
                                            ))
                                        }
                                    </Select>)
                                }
                            </Form.Item>
                        </Col>
                        {isView ? <Col span={12}>
                            <Form.Item name="techMaturity"
                                label={<span className='label'>{t('maturityStar')}</span>}
                                rules={[{ required: true, message: t('Please Select') + (i18n.language !== 'zh' ? ' ' : '') + t('maturityStar') }]}
                            >
                                <span>{dicClassList['技术成熟度'].find(item => item.value === tableEditData.techMaturity)?.name || ''}</span>
                            </Form.Item>
                        </Col> : (authInfo && Reflect.has(authInfo, 'maturityDefine') && <Col span={12}>
                            <Form.Item name="techMaturity"
                                label={<span className='label'>{t('maturityStar')}</span>}
                                rules={[{ required: true, message: t('Please Select') + (i18n.language !== 'zh' ? ' ' : '') + t('maturityStar') }]}
                            >
                                <Select allowClear>
                                    {
                                        dicClassList['技术成熟度'] && dicClassList['技术成熟度'].map(item => (
                                            <Option value={item.value} key={item.value}>{item.name}</Option>
                                        ))
                                    }
                                </Select>
                            </Form.Item>
                        </Col>)}
                        <Form.Item name="patentId" hidden>
                            <Input />
                        </Form.Item>
                    </Row>
                </Space>
                <Row>
                    <Col span={12}>
                        <Form.Item name="isMajorProject"
                            label={<span className='label'>{t('isMajorProject')}</span>}
                            rules={[
                                {
                                    required: true, message: t('Please Select') + (i18n.language !== 'zh' ? ' ' : '') + t('isMajorProject')
                                },
                            ]}
                        >
                            <Radio.Group disabled={isView}>
                                <Radio value={1}>{t('Yes')}</Radio>
                                <Radio value={0}>{t('No')}</Radio>
                            </Radio.Group>
                        </Form.Item>
                    </Col>
                    {isView ? <Col span={12}>
                        <Form.Item name="patentCode"
                            label={<span className='label'>{t('patentCode')}</span>}
                        >
                            <span>{tableEditData.patentCode}</span>
                        </Form.Item>
                        {/* 刘皓明 2023-09-22 10:07 */}
                        {/* 这两个字段我们后续要去跟专利系统打通，先隐藏吧 */}
                        {/* <Form.Item name="patentNum"
                            label={<span className='label'>{t('patentNum')}</span>}
                        >
                            <span>{tableEditData.patentNum}</span>
                        </Form.Item>
                        <Form.Item name="patentStatus"
                            label={<span className='label'>{t('patentStatus')}</span>}
                        >
                            <span>{dicClassList['专利状态'].find(item => item.value === tableEditData.patentStatus)?.name || ''}</span>
                        </Form.Item> */}
                    </Col> : (authInfo && Reflect.has(authInfo, 'patentEdit') && <Col span={12}>
                        <Form.Item name="patentCode"
                            label={<span className='label'>{t('patentCode')}</span>}
                        >
                            <NoSpaceInput allowClear placeholder={t('Please Enter') + (i18n.language !== 'zh' ? ' ' : '') + t('patentCode')} />
                        </Form.Item>
                    </Col>)}
                    <Col span={12}>
                        <Form.Item name="requirementSource"
                            label={<span className='label'>{t('requirementSource')}</span>}
                            rules={[{ required: isPassed, message: t('requirementSource Required') }]}
                        >
                            {isView
                                ? <span>{
                                    dicClassList['requirement source']
                                && dicClassList['requirement source'].find(item => item.value === tableEditData.requirementSource)?.name
                                }</span>
                                : (<Select allowClear>
                                    {
                                        dicClassList['requirement source'] && dicClassList['requirement source'].map(item => (
                                            <Option value={item.value} key={item.value}>{item.name}</Option>
                                        ))
                                    }
                                </Select>)
                            }
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item name="developedBy"
                            label={<span className='label'>{t('developedBy')}</span>}
                            rules={[{ required: isPassed, message: t('developedBy Required') }]}
                        >
                            {isView
                                ? <span>{tableEditData.developedBy}</span>
                                : <NoSpaceInput allowClear />
                            }
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item name="toolsEquipment"
                            label={<span className='label'>{t('toolsAndEquipment')}</span>}
                            rules={[{ required: isPassed, message: t('toolsAndEquipment Required') }]}
                        >
                            {isView
                                ? <span>{tableEditData.toolsEquipment}</span>
                                : <NoSpaceInput allowClear />
                            }
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item name='platformIds'
                            label={<span className='label'>{t('productPlatform')}</span>}
                            rules={[{ required: true, message: t('Please Select')
                            + (i18n.language !== 'zh' ? ' ' : '') + t('productPlatform')
                            }]}
                        >
                            {isView
                                ? tableEditData.platforms?.map((item: any, index: number, arr: any[]) => (<span key={item.id}>
                                    <span>{item.productPlatform}</span>
                                    {index < arr.length - 1 && <span>, </span>}
                                </span>))
                                : <Select allowClear showArrow showSearch
                                    mode='multiple'
                                    filterOption={(input, option: any) => {
                                        return option.children ? (option.children as string).toLowerCase().includes(input.toLowerCase()) : true
                                    }}
                                >
                                    {
                                        prodList.map(item => (
                                            <Option value={item.id} key={item.id}>{item.productPlatform}</Option>
                                        ))
                                    }
                                </Select>}
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item name="relevanceBuss"
                            label={<span className='label'>{t('buStakeholder')}</span>}
                            rules={[{ required: true, message: t('buStakeholder Required') }]}
                        >
                            <Input hidden />
                            {buAttr && buAttr.length > 0 && (<List style={{ marginBottom: 10, background: '#fff' }}
                                bordered
                                dataSource={buAttr}
                                renderItem={(item, index) => <List.Item
                                    key={item.id}
                                    actions={isView ? [] : [
                                        <Text className='txt_red hand' title={t('delete')} key={'buAttr' + index}
                                            onClick={() => {
                                                buAttr.splice(index, 1)
                                                setBuAttr([...buAttr])
                                                formRef.current?.setFieldValue('relevanceBuss', [...buAttr].map((item) => item.id))
                                                formRef.current?.validateFields(['relevanceBuss'])
                                            }}
                                        ><DeleteOutlined style={{ fontSize: 16 }} /></Text>
                                    ]}
                                >{item.bu}</List.Item>}
                            />)}
                            {!isView && <Button
                                onClick={() => {
                                    setShowSelectBu(true)
                                }}
                            >{t('Please Select') + (i18n.language !== 'zh' ? ' ' : '') + t('buAndCtList')}</Button>}
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item name='dutyBuss'
                            label={<span className='label'>{t('developDutySubject')}</span>}
                            rules={[
                                {
                                    required: true,
                                    validator: async () => {
                                        if (!dutyBuss || dutyBuss.length === 0) {
                                            const helpStr = t('Please Select') + (i18n.language !== 'zh' ? ' ' : '') + t('developDutySubject')
                                            return Promise.reject(new Error(helpStr))
                                        } else {
                                            return Promise.resolve()
                                        }
                                    }
                                }
                            ]}
                        >
                            <Input hidden />
                            {dutyBuss && dutyBuss.length > 0 && (<List style={{ marginBottom: 10, background: '#fff' }}
                                bordered
                                dataSource={dutyBuss}
                                renderItem={(item, index) => <List.Item
                                    key={item.id}
                                    actions={isView ? [] : [
                                        <Text className='txt_red hand' title={t('delete')} key={'dutyBuss' + index}
                                            onClick={() => {
                                                dutyBuss.splice(index, 1)
                                                setDutyBuss([...dutyBuss])
                                                formRef.current?.setFieldValue('dutyBuss', [...dutyBuss].map((item) => item.id))
                                                formRef.current?.validateFields(['dutyBuss'])
                                            }}
                                        ><DeleteOutlined style={{ fontSize: 16 }} /></Text>
                                    ]}
                                >{item.bu}</List.Item>}
                            />)}
                            {!isView && <Button
                                onClick={() => {
                                    setShowSelectBu2(true)
                                }}
                            >{t('Please Select') + (i18n.language !== 'zh' ? ' ' : '') + t('buAndCtList')}</Button>}
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item name="resourceNeeded"
                            label={<span className='label'>{t('resourceNeeded')}</span>}
                            rules={[{ required: isPassed, message: t('resourceNeeded Required') }]}
                        >
                            {isView
                                ? <span>{tableEditData.resourceNeeded}</span>
                                : <InputNumber style={{ width: '100%' }} min={0} onChange={(e: number | null) => {
                                    if (e) {
                                        formRef.current?.setFieldValue('resourceNeeded', parseInt('' + (e * 10)) / 10)
                                    }
                                }} />
                            }
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item name="planBudgeting"
                            label={<span className='label'>{t('techPlanCost')}</span>}
                            rules={[{ required: isPassed, message: t('Please Enter')
                            + (i18n.language !== 'zh' ? ' ' : '') + t('techPlanCost')
                            }]}
                        >
                            {isView
                                ? <span>{tableEditData.planBudgeting ? tableEditData.planBudgeting : 0}</span>
                                : <InputNumber style={{ width: '100%' }} min={0} step={1} formatter={value => value ? parseInt('' + value) + '' : ''} />
                            }
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item name="budgeting"
                            label={<span className='label'>{t('budgeting')}</span>}
                        >
                            {isView
                                ? <span>{tableEditData.budgeting ? tableEditData.budgeting : 0}</span>
                                : <InputNumber style={{ width: '100%' }} disabled min={0} step={1} formatter={value => value ? parseInt('' + value) + '' : ''} />
                            }
                        </Form.Item>
                    </Col>
                </Row>
                <Form.Item name="reason" label='新增或修改原因' hidden>
                    <TextArea />
                </Form.Item>
                <Form.Item name="reason" label='说明html' hidden>
                    <div dangerouslySetInnerHTML={editorHtml}></div>
                </Form.Item>
                {
                    isView
                        ? null
                        : (
                            <Form.Item {...tailLayout} style={{ textAlign: 'center' }}>
                                <Space size={20}>
                                    <Button type="primary" htmlType="submit" loading={loading}>{t('submit')}</Button>
                                    {locationObj.pathname.includes('Add') && <Button htmlType="button" onClick={onReset}>{t('reset')}</Button>}
                                </Space>
                            </Form.Item>
                        )
                }
            </Form>
            <SelectBU show={showSelectBu} setShow={setShowSelectBu}
                title={t('select') + (i18n.language !== 'zh' ? ' ' : '') + t('buAndCtList')}
                confirm={selectBuCallback} />
            <SelectBU show={showSelectBu2} setShow={setShowSelectBu2}
                title={t('select') + (i18n.language !== 'zh' ? ' ' : '') + t('buAndCtList')}
                confirm={selectBuCallback2} />
            <SelectProject show={showSelectProjects} setShow={setShowSelectProjects}
                confirm={selectProjectCallBack}
                defaultValue={projectInfo?.projectNo}
            />
        </Space>
    )
}

export default Table1Edit
